import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve si recién me recibí?',
    a: 'Especialmente para vos. Arrancás con estructura de consultorio establecido desde el primer día.'
  }, {
    q: '¿Sirve si ya tengo experiencia?',
    a: 'Sí. Lo que más valoran las nutricionistas experimentadas: Tomo 4 (patologías), Tomo 5 (deporte) y los bonos de primera consulta y menús rotativos.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Email con link de descarga inmediata después del pago. Todo en PDF. En tu dispositivo para siempre.'
  }, {
    q: '¿Es material argentino o genérico?',
    a: '100% argentino. Normativa local vigente, alimentos de góndola argentina, scripts con voseo, referencias a GAPA, MSAL y ANMAT.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días, devolución total, sin preguntas. Escribís a soporte.tumanualdigital@gmail.com y listo.'
  }];
  return <section className="py-8 md:py-20 px-4 max-w-3xl mx-auto" data-id="element-143">
      <FadeIn data-id="element-144">
        <h2 className="text-2xl md:text-5xl font-black text-center mb-6 md:mb-14 flex items-center justify-center gap-3 md:gap-4" data-id="element-145">
          <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" data-id="element-146">
            ❓
          </span>{' '}
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2.5 md:space-y-4" data-id="element-147">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-148" />)}
        </div>
      </FadeIn>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-gray-900 border-green-500/50 shadow-[0_0_20px_rgba(34,197,94,0.1)]' : 'bg-gray-900/50 border-gray-800 hover:border-gray-600'}`} data-id="element-149">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-4 md:px-6 py-4 md:py-6 text-left flex justify-between items-center focus:outline-none gap-3" data-id="element-150">
        <span className={`font-bold text-sm md:text-xl pr-2 md:pr-4 transition-colors ${isOpen ? 'text-green-400' : 'text-gray-200'}`} data-id="element-151">
          {question}
        </span>
        <div className={`shrink-0 p-1.5 md:p-2 rounded-full transition-colors ${isOpen ? 'bg-green-500/20 text-green-500' : 'bg-gray-800 text-gray-400'}`} data-id="element-152">
          {isOpen ? <Minus className="w-4 h-4 md:w-5 md:h-5" data-id="element-153" /> : <Plus className="w-4 h-4 md:w-5 md:h-5" data-id="element-154" />}
        </div>
      </button>
      <AnimatePresence data-id="element-155">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-156">
            <div className="px-4 md:px-6 pb-4 md:pb-6 pt-1 md:pt-2" data-id="element-157">
              <p className="text-gray-300 leading-relaxed text-sm md:text-lg font-medium" data-id="element-158">
                {answer}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}